var scope_0 = require('/vercel/path0/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/14fd21ac272749ba72451aec3083915c.js').default;export default
        Object.assign({}, scope_0 )
    